<ng-container *transloco="let t">
    @let list = list$ | async;
    @if (list) {
        <bazis-label
            [required]="true"
            [title]="t('crypto.selectCertificate')"
        >
        </bazis-label>

        <bazis-autocomplete-static
            [formControl]="certificateControl"
            [multiple]="false"
            [staticOptions]="list"
            placeholderKey="placeholder.selectCertificate"
            [infiniteListTpl]="infiniteListTpl"
            [selectedValueTpl]="selectedValueTpl"
            [multiple]="false"
            [hasEraser]="false"
        ></bazis-autocomplete-static>

        <ng-template
            #infiniteListTpl
            let-item="item"
        >
            @if (item) {
                <div (click)="select(item.$snapshot)">
                    <div class="bazis-text_secondary">{{
                        item.$snapshot.valueMap.O
                            ? item.$snapshot.valueMap.O
                            : item.$snapshot.valueMap.CN
                    }}</div>
                    <div class="bazis-text_minor tms-text_tertiary">
                        {{
                            t('crypto.fromTo', {
                                from: item.$snapshot.fromDate | localDate: 'shortDate',
                                to: item.$snapshot.toDate | localDate: 'shortDate',
                            })
                        }}, № {{ item.$snapshot.valueMap.SN }}
                    </div>
                </div>
            }
        </ng-template>

        <ng-template
            #selectedValueTpl
            let-item="item"
        >
            @if (item) {
                {{
                    item.$snapshot.valueMap.O
                        ? item.$snapshot.valueMap.O
                        : item.$snapshot.valueMap.CN
                }},
                {{
                    t('crypto.fromTo', {
                        from: item.$snapshot.fromDate | localDate: 'shortDate',
                        to: item.$snapshot.toDate | localDate: 'shortDate',
                    })
                }}
            }
        </ng-template>

        <!-- @for (cert of list; track $index) {
            <div
                class="bazis-radio bazis-radio_block"
                [class.bh-events-none]="cert.disabled"
            >
                <label (click)="select(cert)">
                    <input
                        type="radio"
                        name="radio_sert"
                        [disabled]="cert.disabled"
                        [checked]="certificate?.certificate?.objid === cert.certificate.objid"
                        (change)="preventDefault($event)"
                        (click)="preventDefault($event)"
                    />
                    <div class="bazis-radio__label">
                        <div class="bh-overhide">
                            <p>
                                <span class="bh-font-medium">{{ cert?.valueMap.CN }}</span>
                            </p>
                            <p class="bazis-text_secondary">{{ cert?.valueMap.O }}</p>
                            <p class="bazis-text_secondary">
                                {{ cert?.fromDate | localDate: 'shortDate' }},
                                {{ cert?.toDate | localDate: 'shortDate' }}
                            </p>
                        </div>
                    </div>
                </label>
            </div>
        } -->
    } @else {
        <bazis-default-loader
            theme="transparent"
            type="inline"
            loader="dots"
        ></bazis-default-loader>
    }
</ng-container>
